<template>
  <div class="container">
    <div class="date-piker">
      <money
        rounded
        dense
        outlined
        v-model="data"
        v-bind="money"
        @keyup.native="change"
        :disabled="disabled"
        :rules="[(v) => !!v || 'Campo obrigatório']" />
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  name: "ValorMonetario",

  components: { Money },

  props: {
    value: { type: Number },
    disabled: { type: Boolean },
  },

  created() {
    this.assign();
  },

  data() {
    return {
      data: null,
      dataNum: null,
      dataFmt: null,
      fmt: Intl.NumberFormat(
        'pt-BR',
        {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2
        }),
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true
      }
    };
  },

  methods: {
    assign () {
      const nm = +(this.data ? this.data.replace(/\./g, '').replace(',', '.') : '0');
      const vl = !Number.isNaN(nm) && Number.isFinite(nm) ? nm : this.value;
      const dt = !Number.isNaN(vl) &&
                  Number.isFinite(vl) ?
                  this.fmt.format(vl) :
                  '';
      const df = !Number.isNaN(vl) &&
                  Number.isFinite(vl) ?
                  vl.toFixed(2) :
                  '';
      (dt !== this.data) && (this.data = dt);
      (vl !== this.dataNum) && (this.dataNum = vl);
      (df !== this.dataFmt) && (this.dataFmt = df);
    },

    change(){
      this.assign();
      this.$emit("change", this.dataFmt);
    },

    save() {
      this.$emit("save", this.dataFmt);
    }
  },

  watch: {
    value() {
      this.data = this.value !== null && this.value !== undefined ?
        this.value.toFixed(2).replace(/\./, ',') :
        '0,00';
      this.assign();
    },
  },
};
</script>

<style scoped>
.menu {
  border-radius: 50px;
}
.date-piker input {
  width: 100%;
  border: 1px solid #767676;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 40px;
  padding: 0.5rem 0.5rem 0.5rem 2.5rem;
  outline: none;
  position: relative;
}
.v-money {
  color: black;
  border-color: black;
}
/* .date-piker input::-webkit-calendar-picker-indicator {
  color: #a4a4a4 !important;
  background: url("../../../../../assets/icons/calendar_icon.svg") no-repeat;
  position: absolute;
  left: -10px;
} */
</style>